import {arrayFlat} from './array.js';

const termSuggests = [
	'product-code-suggest',
	'gtin-suggest',
	'mpn-suggest',
	'brand-suggest',
	'name-suggest',
];

export function createSuggestedQueries(query, suggestions){
	return arrayFlat([
		arrayFlat(suggestions['name-phrase-suggest'].map(function(suggestion){
			return suggestion.options.map(function(option){
				return {
					value: option.text,
					text: option.highlighted
				};
			});
		})),
		arrayFlat(termSuggests.map(function(key){
			return arrayFlat(suggestions[key].map(function(suggestion){
				var {offset, length, options} = suggestion;

				var start = query.slice(0, offset);
				var end = query.slice(offset + length);

				return options.map(function(option){
					return start + option.text + end;
				});
			}));
		}))
	]).reduce(function(c, o){
		return c.some(function(v){ return (v.value || v) === (o.value || o) })
			? c
			: (c.push(o), c);
	}, []);
}